import React, { Component, useEffect } from 'react';
import Datas from '../data/icon-box/icon-box.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/certificateDemoDisplay";
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import UserService from '../services/UserService';


const CertificateDemoDisplay = () => {
  return (
    <Styles>
      <section className="icon-box-area">
        <Container>
          <Row className='icon-box-heading'>
            <h3><span>Certificates</span></h3>
          </Row>
          <Row className='icon-box'>
            <Col md="6">
              <div className="full-icon-box">
                <div className="icon-box" >
                  <div className='box-logo'>
                    <img src={process.env.PUBLIC_URL + `/assets/images/cert1.png`} alt="Logo" />
                  </div>
                  <div className="box-title">
                    <h6>{"C-DAC Course Completion Certificate"}</h6>
                    {/* <p>{data.subTitle}</p> */}
                  </div>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="full-icon-box">
                <div className="icon-box" >
                  <div className='box-logo'>
                    <img src={process.env.PUBLIC_URL + `/assets/images/cert3.jpg`} alt="Logo"/>
                  </div>
                  <div className="box-title">
                    <h6>{"C-DAC Certified Professional Certificate"}</h6>
                    {/* <p>{data.subTitle}</p> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  )
}

export default CertificateDemoDisplay